
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchant/[merchantLocationId]/menus",
      function () {
        return require("private-next-pages/merchant/[merchantLocationId]/menus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchant/[merchantLocationId]/menus"])
      });
    }
  